export default {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  'tr-TR': {
    currency: {
      style: 'currency',
      currency: 'TRY'
    }
  },
  'ro-RO': {
    currency: {
      style: 'currency',
      currency: 'RON'
    }
  }
}
